import { Navigate } from 'react-router-dom';
import { useAuth } from './useAuth';

export const DefaultRedirect = () => {
  const { isAdmin, isReporteria, loading, initialized } = useAuth();

  // Mostrar loading mientras se inicializa
  if (!initialized || loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#004A98]"></div>
      </div>
    );
  }

  // Redirigir según el rol del usuario
  if (isAdmin) {
    return <Navigate to="/maquinarias" replace />;
  } else if (isReporteria) {
    return <Navigate to="/reportes" replace />;
  }

  // Fallback en caso de que no tenga ningún rol específico
  return <Navigate to="/reportes" replace />;
};